import { CalendarComponentOptions } from 'ion2-calendar'
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { MenuController } from '../../../../node_modules/ionic-angular/components/app/menu-controller';
import { Chart } from 'chart.js';
import { Ortak } from '../../../providers/ortak';
import { BllOrtak } from '../../../providers/bll/bll-ortak';
@Component({
  selector: 'page-reports',
  templateUrl: 'reports.html',
})
export class ReportsPage {
  @ViewChild('sideNavUrunAra') sideNav;
  @ViewChild('chartCanvas') chartCanvas;
  Nakit: number = 0;
  Pos: number = 0;
  VeresiyeTutar: number = 0;
  SatisSayisi: number = 0;
  ToplamGelir: number = 0;
  ToplamGelirGiderFark: number = 0;
  ToplamGider: number = 3;
  ToplamPesinSatisTutari: number = 0;
  ToplamaSatis: number = 0;
  CariTahsilatToplam: number = 0;
  CariOdemeToplam: number = 0;
  chartVar: any;
  tarih1: any;
  tarih2: any;
  raporlar: any = { ToplamNakit: "" };
  RaporListesi: any = {};
  urunRaporListesi=[];
  hataMesaji = "";
  sonucYok: boolean = true;
  sonucVar: boolean = false;
  dateRange: {
    from: Date
    to: Date
  } = {
      from: this.tarih1,
      to: this.tarih2
    };
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  optionsRange: CalendarComponentOptions = {
    from: new Date(2016, 1, 1),
    pickMode: 'range',
    color: "danger",
    monthPickerFormat: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Tem", "Agust", "Eylül", "Ekim", "Kasım", "Aralık"]
  };
  constructor(public navCtrl: NavController,
    public ortak: Ortak,
    public bllOrtak: BllOrtak,
    public navParams: NavParams,
    public menu: MenuController) {
    this.tarih1 = this.ortak.tarih(this.ortak.storageGunTarihiGetir);
    this.tarih2 = this.tarih1;
   
  }
  ionViewDidLoad() {
    this.dateRange.from = this.ortak.storageGunTarihiGetir;
    this.dateRange.to = this.ortak.storageGunTarihiGetir;
    this.closeNav();
    // this.showChart();
    this.gunsonurapor();

  }
  openNav() {
    let sideElement = this.sideNav.nativeElement
    sideElement.style.display = "block";
  }
  closeNav() {
    let sideElement = this.sideNav.nativeElement;
    sideElement.style.display = "none";
  }

  showChart() {
  
    var nakit:number=33.3;
    var pos:number=33.3;
    var versiye:number=33.3;
    if(this.Nakit!=0)
    {
      nakit=this.Nakit;
      pos=this.Pos;
      versiye=this.VeresiyeTutar;
    
    }
    if(this.Pos==0)
    {
      pos=0;
    }
    if(this.Nakit==0)
    {
      nakit=0;
    }
    if(this.VeresiyeTutar==0){
      versiye=0;
    }
  
    this.chartVar = new Chart(this.chartCanvas.nativeElement, {
      type: 'pie',
      data: {
        datasets: [{
          data: [
          nakit,
            pos,
            versiye,
          ],
          backgroundColor: [
            'rgba(38,172,170)',
            'rgba(205,51,51)',
            'rgba(255,228,19)'
          ]
        }],
        labels: [
          'Nakit',
          'Kredi Kartı',
          'Veresiye Satış'
        ]
      },
      options: {
        tooltips: {
          enabled: true
        }
      }
    })
  }
  urunrapor()
  {
    var formData = new FormData();
    formData.append("tarih1", this.ortak.tarih(this.dateRange.from));
       formData.append("tarih2", this.ortak.tarih(this.dateRange.to));
    this.bllOrtak.islem(formData, "UrunSatisRaporu", "", true).then(a => {
      var sonuc = <any>a;
      this.urunRaporListesi = sonuc.SonucObject;
    
    });
  }
  gunsonurapor() {
    var formData = new FormData();
    formData.append("tarih1", this.ortak.tarih(this.dateRange.from));
       formData.append("tarih2", this.ortak.tarih(this.dateRange.to));
    this.bllOrtak.islem(formData, "GunSonuRaporuGetir", "", true).then(a => {
      var sonuc = <any>a;
      this.RaporListesi = sonuc.SonucObject;
       this.Nakit = 0;
      this.Pos = 0;
      this.VeresiyeTutar = 0;
      this.SatisSayisi = 0;
      this.ToplamGelir = 0;
      this.ToplamGelirGiderFark = 0;
      this.ToplamGider = 0;
      this.ToplamPesinSatisTutari = 0;
      this.ToplamaSatis = 0;
      this.CariTahsilatToplam = 0;
      this.CariOdemeToplam = 0;
  
      this.RaporListesi.forEach(element => {
        this.Nakit = parseFloat(element.ToplamNakit.toString());
        this.Pos = parseFloat(element.ToplamPOS.toString());
        this.VeresiyeTutar = parseFloat(element.ToplamVeresiye.toString());
        this.SatisSayisi = parseFloat(element.SatisSayisi.toString());
        this.ToplamPesinSatisTutari = parseFloat(element.ToplamPesinSatisTutari.toString());
        this.CariTahsilatToplam = parseFloat(element.CariTahsilatToplam.toString());
        this.CariOdemeToplam = parseFloat(element.CariOdemeToplam.toString());
        this.ToplamaSatis = parseFloat(element.ToplamaSatis.toString());

      
      });
      if(this.Nakit==null)
      {
        this.Nakit=0;
        
      }
      if(this.Pos==null)
      {
        this.Pos=0;

      }
      if(this.VeresiyeTutar==null)
      {
        this.VeresiyeTutar=0;
      }
      if(this.RaporListesi!=null)
      {
        this.showChart()
      }
     
     
    })
    this.closeNav();
  }
}





// WEBPACK FOOTER //
// ./src/pages/Raporlars/reports/reports.ts